import template from "./select-search.html";
import {selectSearchController} from "./select-search.controller";
import "./select-search.scss";

export const selectSearchComponent = {
	template,
	controller: selectSearchController,
	controllerAs: "selectSearch",
	bindings: {
		model: "=",
		itemLabel: "@",
		itemValue: "@",
		label: "<",
		searchLabel: "<",
		collection: "<",
		required: "@",
		onValueChange: "&",
		allowNoValue: "@"
	}
};



// WEBPACK FOOTER //
// ./sources/components/common/select-search/select-search.component.js